<ng-container *ngIf="isForbiddenSalesArea$ | async">
  <div class="alert warning alert-warning">
    <span [innerHtml]="resolveMessage()"></span>
  </div>
</ng-container>
